export default __webpack_public_path__ + "static/media/39_jpeg.1dff685f.jpg";